import axios from 'axios';

class WeatherService {

    getCurrentWeather() {
        return axios.get(`http://api.openweathermap.org/data/2.5/weather?q=boulogne-billancourt&appid=dba561b0a24163338e9909b469cb6d8c&units=metric`);
    }
}

export default (new WeatherService()); // singleton object